import React, { useState } from 'react';
import EventReportProduct from '@/model/EventReportProduct';
import EventMainReport from '@/model/EventMainReport';
import { EventProductMainReport } from '@/model/EventProductMainReport';
import { EventSectionSaleProductReport } from '@/model/EventSectionSaleProductReport';
import { EventMachineSaleProductReport } from '@/model/EventMachineSaleProductReport';
import { EventPdvSaleProductReport } from '@/model/EventPdvSaleProductReport';
import { States } from '@/helpers/common/states';
import { ReportControllerProps } from '../../types';
import { SaleProdutContent } from './ui';
import { SaleProductProducts } from '../SaleProductProducts';
import { SaleProductSections } from '../SaleProductSections';
import { SaleProductMachine } from '../SaleProductMachine';
import { SaleProductPdv } from '../SaleProductPdv';
import { exportProductPDF } from './pdf/exportProductPDF';
import { exportSectionsPDF } from '../SaleProductSections/pdf/exportSectionsPDF';
import { exportMachinePDF } from '../SaleProductMachine/pdf/exportMachinePDF';
import { exportPdvPDF } from '../SaleProductPdv/pdf/exportPdvPDF';

interface SaleDateProps {
  event: EventMainReport;
  product: EventReportProduct;
  reportController: ReportControllerProps;
  generatePDF: () => void;
}

export const SaleProduct: React.FC<SaleDateProps> = ({
  event,
  product,
  reportController,
  generatePDF: _generatePDF,
}) => {
  const [state, setState] = useState<States>(States.default);

  const handleExportProductPDF = (mainData: EventProductMainReport): void => {
    exportProductPDF(event, mainData);
  };

  const handleExportSectionsPDF = (sections: EventSectionSaleProductReport[]): void => {
    exportSectionsPDF(event, sections);
  };

  const handleExportMachinePDF = (machines: EventMachineSaleProductReport[]): void => {
    exportMachinePDF(event, machines);
  };

  const handleExportPdvPDF = (pdvs: EventPdvSaleProductReport[]): void => {
    exportPdvPDF(event, pdvs);
  };

  const [steps, setSteps] = useState<any[]>([
    {
      component: (
        <SaleProductProducts
          event={event}
          product={product}
          reportController={reportController}
          setState={setState}
          onExportPDF={handleExportProductPDF}
        />
      ),
      title: 'Produtos',
      completion: true,
      status: 'current',
    },
    {
      component: (
        <SaleProductSections
          reportController={reportController}
          setState={setState}
          onExportPDF={handleExportSectionsPDF}
        />
      ),
      title: 'Setores',
      completion: true,
      status: 'done',
    },
    {
      component: (
        <SaleProductMachine
          reportController={reportController}
          setState={setState}
          onExportPDF={handleExportMachinePDF}
        />
      ),
      title: 'POS',
      completion: true,
      status: 'done',
    },
    {
      component: (
        <SaleProductPdv
          reportController={reportController}
          setState={setState}
          onExportPDF={handleExportPdvPDF}
        />
      ),
      title: 'PDVs',
      completion: true,
      status: 'done',
    },
  ]);

  const handleClickStep = (step: number): void => {
    const newSteps = steps.map((s, index) => {
      if (index < step) {
        return { ...s, status: 'done' };
      }
      if (index === step) {
        return { ...s, status: 'current' };
      }
      return { ...s, status: 'todo' };
    });

    setSteps(newSteps);
  };

  return (
    <SaleProdutContent
      state={state}
      product={product}
      steps={steps}
      handleClickStep={handleClickStep}
    />
  );
};
